import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82df5a6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "loading-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { UserNotification as UserNotification } from "../types/user-notifications-interface";
import NotificationDropdownListItem from "./notification-dropdown-list-item.vue";
import BaseNothingToShow from "@/ui-library/base-nothing-to-show/base-nothing-to-show.vue";
import BaseDropDownList from "@/ui-library/base-drop-down-list/base-drop-down-list.vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";
import BaseButton from "@/ui-library/base-button/base-button.vue";
import BaseLoader from "@/ui-library/base-loader/base-loader.vue";
import BellIcon from "@/ui-library/icons/bell-icon.vue";
import BaseNotificationDot from "@/ui-library/base-notification-dot/base-notification-dot.vue";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'notification-drop-down-list',
  props: {
    notifications: null,
    hasUnreadNotifications: { type: Boolean },
    isLoading: { type: Boolean },
    currentPage: null,
    totalPages: null,
    handleNotificationClick: null,
    handleScroll: null
  },
  setup(__props: any) {

const props = __props as {
  notifications: UserNotification[];
  hasUnreadNotifications: boolean;
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  handleNotificationClick: (notification: UserNotification) => void;
  handleScroll: (event: Event) => void;
}



const hasFecthedAllNotifiations = computed(() => {
  return props.currentPage >= props.totalPages;
});

const nothingToShowMessage = "No notifications to show";
const showingAllNotificationsText = "Showing all notifications";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDropDownList, { class: "bell-container" }, {
    button: _withCtx(() => [
      _createVNode(BaseButton, {
        tertiary: "",
        class: "title-row"
      }, {
        default: _withCtx(() => [
          _createVNode(BaseTypography, {
            body2: "",
            noMargin: "",
            class: _normalizeClass({ 'has-unread': __props.hasUnreadNotifications })
          }, {
            default: _withCtx(() => [
              _createVNode(BellIcon),
              _createVNode(BaseNotificationDot, {
                hasUnread: props.hasUnreadNotifications,
                class: "notification-dot"
              }, null, 8, ["hasUnread"])
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    list: _withCtx(() => [
      _createElementVNode("div", {
        class: "notifications-list-container",
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.handleScroll && __props.handleScroll(...args)))
      }, [
        (props.notifications.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.notifications, (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notification.id
                }, [
                  _createVNode(NotificationDropdownListItem, {
                    notification: notification,
                    handleNotificationClick: props.handleNotificationClick
                  }, null, 8, ["notification", "handleNotificationClick"])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_2, [
                (props.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(BaseLoader, { position: "relative" })
                    ]))
                  : (_unref(hasFecthedAllNotifiations))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(BaseTypography, { subtitle3: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(showingAllNotificationsText))
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createBlock(BaseNothingToShow, {
              key: 1,
              class: "empty-notifications-list-container",
              message: nothingToShowMessage
            }))
      ], 32)
    ]),
    _: 1
  }))
}
}

})